var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FormItem',{class:{'ugo-hide-label':true},attrs:{"label":_vm.label}},[_c('BaseFlexTable',{staticStyle:{"border":"1px solid var(--border)"},attrs:{"columns":_vm.config?.cols || [],"model":_vm.db,"summary":_vm.config?.summary},on:{"input":_vm.handleSave},model:{value:(_vm.items),callback:function ($$v) {_vm.items=$$v},expression:"items"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }